import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=4598a4dd&scoped=true&"
import script from "./SubmitButton.vue?vue&type=script&lang=js&"
export * from "./SubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=4598a4dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598a4dd",
  null
  
)

export default component.exports